import Link from "next/link";
import styles from './style.module.css';

interface Props {
  children?: React.ReactNode,
  onClick?: any,
  href?: string,
  style?: string
}

export const InputText: React.FC<Props> = ({children, onClick, href, style}) => {

  if (!style) {
    style = styles.btn
  } else if (style === "sub") {
    style = styles.sub_btn
  }

  if (href) {
    return (
      <Link href={href} prefetch={false}>
        <a {...onClick && (onClick={onClick})} className={style}>{children}</a>
      </Link>
    )
  }
  else {
    return (
      <span {...onClick && (onClick={onClick})} className={style}>
        {children}
      </span>
    )
  }
}

export default InputText;
